import React, { useState } from "react";
import styles from "./AddComment.module.css";
import CommentEditPopup from "./CommentEditPopup";
import moment from "moment";
import { useAuthUser } from "react-auth-kit";
import DeletePopup from "../../DeletePopup/DeletePopup";
import { useSelector, useDispatch } from "react-redux";
import { deleteComment } from "../../../pages/app/Nurture/service/nurtureSlice";
import getTeamMember from "../../CommonFunctions/CommonFunctions";
import { getSubDomainAccessStatus } from "../../RolePermissionAccess/RolePermissionAccess";
import { getDescriptionWithMentionedNames } from "../../CommonFunctions/CommonFunctions";

function CommentListItem(props: any) {
  const {
    employees,
    commentData,
    setShowAddComment,
    setFromCommentEdit,
    setCommentForEditing,
    DeleteComment,
    leadById,
    setTaskIdForComment,
    taskId,
    commentIdFromUrl,
    isGeneralTask,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();
  const { userById } = useSelector((state: any) => state.userDetails);

  const hasLeadAccess = getSubDomainAccessStatus(
    "NURTURE_BOARD",
    "LEAD_CARD",
    "ALL_ACCESS",
    userById?.rolePermission,
  );
  const { deleteCommentLoading, deleteCommentSuccess } = useSelector(
    (state: any) => state.nurture,
  );

  const modifiedDescription = getDescriptionWithMentionedNames(
    commentData?.description,
    employees,
  ).replace(/\n/g, "<br>");

  const handleEditButtonClick = (val: any) => {
    setShowAddComment(true);
    setCommentForEditing(val);
    setFromCommentEdit(true);
    setTaskIdForComment(taskId);
  };

  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [dataForDelete, setDataForDelete] = useState<any>();

  React.useEffect(() => {
    if (deleteCommentSuccess !== false && deleteCommentSuccess !== true) {
      setShowDeletePopup(false);
      setDataForDelete(undefined);
    }
  }, [deleteCommentSuccess]);

  const handleDeleteButtonClick = () => {
    setShowDeletePopup(true);
    setDataForDelete(commentData);
  };

  const handlePopupYesButton = () => {
    if (authUser && authUser?.institute?.[0]) {
      const data: any = {
        idsToDelete: [dataForDelete?.id],
        instituteId: authUser?.institute?.[0]?.instituteId,
        updatedById: authUser?.institute?.[0]?.id,
        updatedByName: authUser?.firstName + " " + authUser?.lastName,
        taskId: taskId, // Include taskId to update the correct task's commentList
      };

      if (isGeneralTask) {
        data.isGeneralTaskComment = true;
      } else if (leadById) {
        data.enquiryId = leadById?.id;
        data.studentName =
          leadById?.studentFirstName + leadById?.studentLastName;
        data.studentEmail = leadById?.studentEmail;
        data.swimlaneState = leadById?.enquirySwimlaneStatus;
      }

      dispatch<any>(deleteComment(data));
    }
  };

  const handlePopupNoButton = () => {
    setShowDeletePopup(false);
  };
  const creatorId = authUser?.institute?.[0]?.id;

  return (
    <div className={styles.commentItemWrap} key={commentData?.id}>
      <div className={styles.commentItemBorder}></div>
      <div
        className={styles.commentItemRight}
        style={{
          background:
            commentIdFromUrl === commentData?.id ? "#e8faf6" : "transparent",
          padding:
            commentIdFromUrl === commentData?.id ? "5px 5px 5px 5px" : "0px",
          borderRadius: commentIdFromUrl === commentData?.id ? "4px" : "0px",
          transition: "0.1s ease-in-out",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "5px",
          }}
        >
          <div className={styles.commentItemCreatorDetails}>
            <div className={styles.commentItemCreatorAvatar}>
              {getTeamMember(
                commentData?.createdById,
                employees,
              )?.firstName?.charAt(0)}
            </div>
            <div className={styles.commentItemCreatorDetailsRight}>
              <div className={styles.commentItemCreatorName}>
                {getTeamMember(commentData?.createdById, employees)?.firstName +
                  " " +
                  getTeamMember(commentData?.createdById, employees)?.lastName}
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "4px" }}
              >
                <div className={styles.commentItemCreatorDate}>
                  {moment(commentData?.creationDate).format("MMM DD, hh:mm A")}
                </div>
                {commentData?.updatedByName !== "" && (
                  <div className={styles.commentItemCreatorDate}>| Edited</div>
                )}
              </div>
            </div>
          </div>
          <div>
            {creatorId === commentData?.createdById &&
              (isGeneralTask || hasLeadAccess) && (
                <>
                  <CommentEditPopup
                    handleEditButtonClick={handleEditButtonClick}
                    handleDeleteButtonClick={handleDeleteButtonClick}
                    data={commentData}
                  />
                  {showDeletePopup && (
                    <DeletePopup
                      type={"comment"}
                      handlePopupYesButton={handlePopupYesButton}
                      handlePopupNoButton={handlePopupNoButton}
                      loading={deleteCommentLoading}
                    />
                  )}
                </>
              )}
          </div>
        </div>

        <div
          className={styles.commentItemDesc}
          dangerouslySetInnerHTML={{ __html: modifiedDescription }}
        ></div>
      </div>
    </div>
  );
}

export default CommentListItem;
